/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../app/pipe/number-collection.pipe';
import * as i3 from '../../../app/common/pagination.component';
const styles_PaginationComponent:any[] = ([] as any[]);
export const RenderType_PaginationComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_PaginationComponent,data:{}});
function View_PaginationComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'col-sm-12']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(1,(null as any),['\n  Showing ',' to ',' of ',' entries\n']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = ((_co.page * _co.size) + 1);
        const currVal_1:any = ((_co.page * _co.size) + _co.numberOfElements);
        const currVal_2:any = _co.totalElement;
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
      });
}
function View_PaginationComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),6,'li',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(1,
      278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
          i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),i0.ɵpod(2,{'active':0}),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),3,'a',([] as any[]),(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.changePage((_v.context.$implicit - 1))) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(4,(null as any),['',''])),
      (_l()(),i0.ɵeld(5,0,(null as any),(null as any),1,'span',[['class','sr-only']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['(currenct)']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _ck(_v,2,0,(_v.context.$implicit === (_co.page + 1)));
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,4,0,currVal_1);
  });
}
function View_PaginationComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),22,'div',[['style',
      'text-align:center; margin-top:20px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i0.ɵeld(2,0,(null as any),(null as any),19,'ul',[['class','pagination'],['style',
          'display:inline-block; margin-top:50px;']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵeld(4,0,(null as any),(null as any),5,'li',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(5,278528,
          (null as any),0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
              i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),i0.ɵpod(6,{'disabled':0}),
      (_l()(),i0.ɵeld(7,0,(null as any),(null as any),2,'a',[['aria-label','Previous']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.changePage((_co.pageStart - 11))) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵeld(8,0,(null as any),(null as any),
          1,'span',[['aria-hidden','true']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['«'])),(_l()(),
          i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),2,(null as any),View_PaginationComponent_3)),i0.ɵdid(12,802816,
          (null as any),0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),i0.ɵppd(13,1),(_l()(),i0.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i0.ɵeld(15,0,(null as any),(null as any),
          5,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),i0.ɵdid(16,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
          i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i0.ɵpod(17,{'disabled':0}),(_l()(),i0.ɵeld(18,0,(null as any),(null as any),
          2,'a',[['aria-label','Next']],(null as any),[[(null as any),'click']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.changePage((_co.pageStart + 9))) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵeld(19,0,(null as any),(null as any),
          1,'span',[['aria-hidden','true']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['»'])),(_l()(),
          i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _ck(_v,6,0,(_co.pageStart < 11));
        _ck(_v,5,0,currVal_0);
        const currVal_1:any = i0.ɵunv(_v,12,0,_ck(_v,13,0,i0.ɵnov((<any>_v.parent),
            0),_co.pageEnd));
        _ck(_v,12,0,currVal_1);
        const currVal_2:any = _ck(_v,17,0,(_co.pageEnd === _co.totalPage));
        _ck(_v,16,0,currVal_2);
      },(null as any));
}
export function View_PaginationComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵpid(0,i2.NumberCollectionPipe,([] as any[])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_PaginationComponent_1)),i0.ɵdid(2,
      16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),
      i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationComponent_2)),
      i0.ɵdid(5,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i3.PaginationComponent = _v.component;
        const currVal_0:any = (_co.totalElement > 0);
        _ck(_v,2,0,currVal_0);
        const currVal_1:any = (_co.totalElement > 0);
        _ck(_v,5,0,currVal_1);
      },(null as any));
}
export function View_PaginationComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-pagination',
      ([] as any[]),(null as any),(null as any),(null as any),View_PaginationComponent_0,
      RenderType_PaginationComponent)),i0.ɵdid(1,114688,(null as any),0,i3.PaginationComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PaginationComponentNgFactory:i0.ComponentFactory<i3.PaginationComponent> = i0.ɵccf('app-pagination',
    i3.PaginationComponent,View_PaginationComponent_Host_0,{page:'page',size:'size',
        totalPage:'totalPage',totalElement:'totalElement',pageStart:'pageStart',pageEnd:'pageEnd',
        numberOfElements:'numberOfElements'},{movePage:'movePage'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2NvbW1vbi9wYWdpbmF0aW9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2dpdGxhYi1ydW5uZXIvYnVpbGRzL2Q5MGM1YmNmLzAvZ2FpYS9nYWlhLXVpLWFuZ3VsYXIvc3JjL2FwcC9jb21tb24vcGFnaW5hdGlvbi5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2dpdGxhYi1ydW5uZXIvYnVpbGRzL2Q5MGM1YmNmLzAvZ2FpYS9nYWlhLXVpLWFuZ3VsYXIvc3JjL2FwcC9jb21tb24vcGFnaW5hdGlvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2NvbW1vbi9wYWdpbmF0aW9uLmNvbXBvbmVudC50cy5QYWdpbmF0aW9uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNvbC1zbS0xMlwiICpuZ0lmPVwidG90YWxFbGVtZW50ID4gMFwiPlxuICBTaG93aW5nIHt7cGFnZSAqIHNpemUgKyAxfX0gdG8ge3twYWdlICogc2l6ZSArIG51bWJlck9mRWxlbWVudHN9fSBvZiB7e3RvdGFsRWxlbWVudH19IGVudHJpZXNcbjwvZGl2PlxuPGRpdiAqbmdJZj1cInRvdGFsRWxlbWVudCA+IDBcIiBzdHlsZT1cInRleHQtYWxpZ246Y2VudGVyOyBtYXJnaW4tdG9wOjIwcHhcIj5cbiAgPHVsIGNsYXNzPVwicGFnaW5hdGlvblwiIHN0eWxlPVwiZGlzcGxheTppbmxpbmUtYmxvY2s7IG1hcmdpbi10b3A6NTBweDtcIj5cbiAgICA8bGkgW25nQ2xhc3NdPVwieydkaXNhYmxlZCc6dGhpcy5wYWdlU3RhcnQgPCAxMX1cIj48YSAoY2xpY2spPVwiY2hhbmdlUGFnZShwYWdlU3RhcnQgLSAxMSlcIiBhcmlhLWxhYmVsPVwiUHJldmlvdXNcIj48c3BhbiBhcmlhLWhpZGRlbj1cInRydWVcIj4mbGFxdW87PC9zcGFuPjwvYT48L2xpPlxuICAgIDxsaSAqbmdGb3I9J2xldCBpbmRleCBvZiBwYWdlRW5kIHwgbnVtYmVyQ29sbGVjdGlvbicgW25nQ2xhc3NdPVwieydhY3RpdmUnOmluZGV4ID09PSBwYWdlKzF9XCI+PGEgKGNsaWNrKT1cImNoYW5nZVBhZ2UoaW5kZXgtMSlcIj57e2luZGV4fX08c3BhbiBjbGFzcz1cInNyLW9ubHlcIj4oY3VycmVuY3QpPC9zcGFuPjwvYT48L2xpPlxuICAgIDxsaSBbbmdDbGFzc109XCJ7J2Rpc2FibGVkJzp0aGlzLnBhZ2VFbmQgPT09IHRoaXMudG90YWxQYWdlfVwiPjxhIChjbGljayk9XCJjaGFuZ2VQYWdlKHBhZ2VTdGFydCArIDkpXCIgYXJpYS1sYWJlbD1cIk5leHRcIj48c3BhbiBhcmlhLWhpZGRlbj1cInRydWVcIj4mcmFxdW87PC9zcGFuPjwvYT48L2xpPlxuICA8L3VsPlxuPC9kaXY+XG4iLCI8YXBwLXBhZ2luYXRpb24+PC9hcHAtcGFnaW5hdGlvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBZ0Q7OztRQUFBO1FBQUE7UUFBQTtRQUFBOzs7O29CQU01QztNQUFBLCtFQUFBO01BQUE7cUJBQUEsZ0RBQXFEO01BQXdDO1VBQUE7WUFBQTtZQUFBO1lBQUc7Y0FBQTtjQUFBO1lBQUE7WUFBSDtVQUFBLGdDQUFpQztNQUFTO1VBQUE7TUFBc0I7O0lBQXhHO0lBQXJELFdBQXFELFNBQXJEOztJQUE4SDtJQUFBOzs7O29CQUhsSTtNQUFBO01BQUEsOEJBQXlFLDRDQUN2RTthQUFBO1VBQUE7VUFBQSw4QkFBc0U7TUFDcEU7VUFBQSxpRUFBQTtVQUFBO3lCQUFBLGdEQUFJO01BQTZDO1VBQUE7WUFBQTtZQUFBO1lBQUc7Y0FBQTtjQUFBO1lBQUE7WUFBSDtVQUFBLGdDQUE4RDtVQUFBO1VBQUEsOEJBQXlCLHlDQUF1QjtpQkFBQSwrQkFDL0o7VUFBQSxrRUFBQTtVQUFBO1VBQUEsOENBQUksT0FBbUw7VUFBQSwyQkFDdkw7VUFBQTtVQUFBLHVCQUFBO3NEQUFBO2FBQUksb0JBQXlEO1VBQUE7dUJBQUE7WUFBQTtZQUFBO1lBQUc7Y0FBQTtjQUFBO1lBQUE7WUFBSDtVQUFBLGdDQUF5RDtVQUFBO1VBQUEsOEJBQXlCLHlDQUF1QjtpQkFBQSw2QkFDbks7OztRQUhDO1FBQUosV0FBSSxTQUFKO1FBQ0k7WUFBQTtRQUFKLFlBQUksU0FBSjtRQUNJO1FBQUosWUFBSSxTQUFKOzs7O3FFQVBKO01BQUEsZ0ZBQUE7TUFBQTtVQUFBLHdCQUVNLDBDQUNOO2FBQUE7YUFBQTtVQUFBLGlDQU1NOzs7UUFUaUI7UUFBdkIsV0FBdUIsU0FBdkI7UUFHSztRQUFMLFdBQUssU0FBTDs7OztvQkNIQTtNQUFBO29DQUFBLFVBQUE7TUFBQTtJQUFBOzs7Ozs7In0=



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/$$_gendir/app/common/pagination.component.ngfactory.ts